module.exports = ".loading-modal {\n    /* background: #e9e9e9; */\n    position: relative;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    opacity: 0.35;\n    cursor: wait;\n}\n\n.loading-modal img {\n    width: 50px;\n    height: 50px;\n    position: relative;\n    top: 10%;\n    left: 48%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/roteiro-modal/roteiro-modal.component.css
// module id = ./src/app/modal/roteiro-modal/roteiro-modal.component.css
// module chunks = main